// 🔐 accounts (09-30): read the account state in a component. Starts the
// one-time init on first use (inert and network-free while sign-in is off).
import { useEffect, useState } from 'react';
import { getAccountState, subscribeAccount, initAccount } from './accountState';

export function useAccount() {
  const [account, setAccount] = useState(getAccountState);
  useEffect(() => {
    const off = subscribeAccount(setAccount);
    initAccount().then(() => setAccount(getAccountState()));
    return off;
  }, []);
  return account;
}
